// React Router navigation only; legacy appHistory removed.
import { PATHNAME as BROWSE_PATHNAME } from "app/ui/pages/browse.page";
import { PATHNAME as SEARCH_PATHNAME } from "app/ui/pages/search.page";

export class NavigateService {
    // Use useLocation from React Router in components to get current parameters and pathname.

    static getActionLinkWithParams(action: string, params?: URLSearchParams): string {
        return action + (params ? "?" + params.toString() : "");
    }

    static retainOnly(params: URLSearchParams | undefined, retainKeys: string[]): URLSearchParams {
        const currentKeys: string[] = [];

        if (params === undefined) {
            return new URLSearchParams();
        }

        const regex = /(^|&)([^=]*)=/g;
        const text = params.toString();
        let match = regex.exec(text);
        while (match) {
            currentKeys.push(match[2]);
            match = regex.exec(text);
        }

        for (const key of currentKeys) {
            if (!retainKeys.includes(key)) {
                params.delete(key);
            }
        }
        return params;
    }

    static setParams(pathname: string, params?: URLSearchParams): string {
        return NavigateService.getActionLinkWithParams(pathname, params);
    }

    /* --- SEARCH --- */

    static getSearchLinkWithParams(params?: URLSearchParams): string {
        return NavigateService.getActionLinkWithParams(SEARCH_PATHNAME, params);
    }

    static getSearchLink(key?: string, options?: any, params?: URLSearchParams): string {
        params = params ? new URLSearchParams(params.toString()) : new URLSearchParams();
        NavigateService.retainOnly(params, ["source"]);
        if (key) {
            params.set("key", key);
        }
        for (const option in options) {
            params.set(option, options[option]);
        }
        return NavigateService.getSearchLinkWithParams(params);
    }

    static searchWithParams(params?: URLSearchParams): string {
        return NavigateService.getSearchLinkWithParams(params);
    }

    static search(key?: string, options?: any, params?: URLSearchParams): string {
        return NavigateService.getSearchLink(key, options, params);
    }

    /* --- BROWSE / VIEW --- */

    static getBrowseLinkWithParams(params?: URLSearchParams): string {
        params = NavigateService.retainOnly(params, ["source", "uri", "tab"]);
        return NavigateService.getActionLinkWithParams(BROWSE_PATHNAME, params);
    }

    static getBrowseLink(iri?: string, params?: URLSearchParams): string {
        params = params ? new URLSearchParams(params.toString()) : new URLSearchParams();
        params.delete("tab");
        params.delete("key");
        params.delete("limit");

        if (!iri || iri == "urn:laces:concept:all") {
            params.delete("uri");
        } else {
            params.set("uri", iri);
        }

        return NavigateService.getBrowseLinkWithParams(params);
    }

    static browseWithParams(params?: URLSearchParams): string {
        return NavigateService.getBrowseLinkWithParams(params);
    }

    static browse(iri?: string, params?: URLSearchParams): string {
        // Force a refresh when redirecting a publication version is updated and the user is at the starting page
        return NavigateService.getBrowseLink(iri, params).replace("/view", "/");
    }

    static getAbsoluteURL(relURL: string) {
        const curURL = window.location.href;
        const base = curURL.split("#")[0].split("?")[0];
        const absURL = base + "#" + relURL;
        console.log("absURL = " + absURL);
        return absURL;
    }
}
